import React, { useState } from 'react';
import DangerPanel from './DangerPanel';
import FancyButton from './FancyButton';
import './FancyButton.css';
export function exportPlayerIdUrl() {
  const playerId = localStorage.getItem('playerId');
  if (!playerId) return '';
  const basePath = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '');
  const importPath = `${basePath}/import`;
  const url = new URL(importPath, window.location.origin);
  url.searchParams.set('pid', playerId);
  return url.toString();
}

const BookmarkLinkButton: React.FC = () => {
  const [showPanel, setShowPanel] = useState(false);
  const [link, setLink] = useState('');

  const handleClick = () => {
    const url = exportPlayerIdUrl();
    setLink(url);
    setShowPanel(true);
  };

  const fields = [
    {
      label: 'Bookmark/Restore Link',
      value: link
    },
    {
      label: 'Warning',
      value: 'Anyone with this link can play your save.\n\nKeep it private if you do not want to share your progress.'
    }
  ];

  return (
    <>
      <FancyButton
        onClick={handleClick}
        variant="red"
      >
        EXPORT
      </FancyButton>
      {showPanel && (
        <DangerPanel
          fields={fields}
          title="DANGER"
          onClose={() => setShowPanel(false)}
        />
      )}
    </>
  );
};

export default BookmarkLinkButton;
